/**
 * Light by default, dark offered.
 *
 * The prototype was dark-first because it was built to be shown in a meeting
 * room. This is a reading tool, so the default is inverted. The choice is
 * remembered per browser; a viewer who has expressed no preference gets light
 * rather than following the operating system, because the operating system
 * does not know they are about to read scanned newsprint for two hours.
 */

const STORAGE_KEY = 'jl.theme'

export type Theme = 'light' | 'dark'

export function currentTheme(): Theme {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored === 'dark' || stored === 'light') {
      return stored
    }
  } catch {
    // Private browsing, or storage disabled. Light is the answer either way.
  }
  return 'light'
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme)
  try {
    localStorage.setItem(STORAGE_KEY, theme)
  } catch {
    // Not being able to remember the choice is not a reason to refuse it.
  }
}

export function toggleTheme(): Theme {
  const next: Theme = currentTheme() === 'dark' ? 'light' : 'dark'
  applyTheme(next)
  return next
}
